import {Component, DestroyRef, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {HarbourDuesEquipmentLength, HarbourDuesEquipmentType} from "@portbase/bezoekschip-service-typescriptmodels";
import {TitleCasePipe} from "@angular/common";
import {FormControl} from "@angular/forms";

import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
  selector: 'app-equipment-category-amsterdam',
  templateUrl: './equipment-category-amsterdam.component.html',
  styleUrls: ['./equipment-category-amsterdam.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EquipmentCategoryAmsterdamComponent implements OnInit {

  @Input() equipmentType: HarbourDuesEquipmentType | null;
  @Input() equipmentLength: HarbourDuesEquipmentLength | null;

  @Output() equipmentTypeChange = new EventEmitter<HarbourDuesEquipmentType>();
  @Output() equipmentLengthChange = new EventEmitter<HarbourDuesEquipmentLength>();

  category = new FormControl('');


  constructor(private destroyRef: DestroyRef) { }

  ngOnInit(): void {
    this.category.setValue(this.formatCategory(this.equipmentType, this.equipmentLength));
    this.category.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(value => {
        if (value) {
          this.equipmentTypeChange.emit(value.startsWith('C') ? HarbourDuesEquipmentType.CONTAINER : HarbourDuesEquipmentType.FLAT);
          this.equipmentLengthChange.emit(this.equipmentFrom(value))
        }
      });
  }

  equipmentCategories() {
    let array: string[] = [];
    let harbourDuesEquipmentTypes = [HarbourDuesEquipmentType.CONTAINER, HarbourDuesEquipmentType.FLAT];
    let harbourDuesEquipmentLengths = [
      HarbourDuesEquipmentLength.TWENTY_FEET,
      HarbourDuesEquipmentLength.TWENTY_FIVE_FEET,
      HarbourDuesEquipmentLength.THIRTY_FEET,
      HarbourDuesEquipmentLength.THIRTY_FIVE_FEET,
      HarbourDuesEquipmentLength.FORTY_FEET,
      HarbourDuesEquipmentLength.FORTY_FIVE_FEET,
    ];
    for (let i = 0; i < harbourDuesEquipmentTypes.length; i++) {
      for (let j = 0; j < harbourDuesEquipmentLengths.length; j++) {
        array.push(this.formatCategory(harbourDuesEquipmentTypes[i], harbourDuesEquipmentLengths[j]));
      }
    }
    return array;
  }

  formatCategory(harbourDuesEquipmentType: HarbourDuesEquipmentType, harbourDuesEquipmentLength: HarbourDuesEquipmentLength) {
    if (harbourDuesEquipmentType && harbourDuesEquipmentLength) {
      return this.formatHarbourDuesEquipmentType(harbourDuesEquipmentType) + ' ' + this.formatHarbourDuesEquipmentLength(harbourDuesEquipmentLength);
    }
    return null;
  }

  formatHarbourDuesEquipmentType(harbourDuesEquipmentType: HarbourDuesEquipmentType) {
    return new TitleCasePipe().transform(harbourDuesEquipmentType);
  }

  formatHarbourDuesEquipmentLength(harbourDuesEquipmentLength: HarbourDuesEquipmentLength) {
    switch (harbourDuesEquipmentLength) {
      case HarbourDuesEquipmentLength.TWENTY_FEET:
        return '20ft';
      case HarbourDuesEquipmentLength.TWENTY_FIVE_FEET:
        return '25ft';
      case HarbourDuesEquipmentLength.THIRTY_FEET:
        return '30ft';
      case HarbourDuesEquipmentLength.THIRTY_FIVE_FEET:
        return '35ft';
      case HarbourDuesEquipmentLength.FORTY_FEET:
        return '40ft';
      case HarbourDuesEquipmentLength.FORTY_FIVE_FEET:
        return '45ft';
      default:
        return '';
    }
  }

  equipmentFrom(s: string) {
    switch (s.split(' ')[1]) {
      case '20ft':
        return HarbourDuesEquipmentLength.TWENTY_FEET;
      case '25ft':
        return HarbourDuesEquipmentLength.TWENTY_FIVE_FEET;
      case '30ft':
        return HarbourDuesEquipmentLength.THIRTY_FEET;
      case '35ft':
        return HarbourDuesEquipmentLength.THIRTY_FIVE_FEET;
      case '40ft':
        return HarbourDuesEquipmentLength.FORTY_FEET;
      case '45ft':
        return HarbourDuesEquipmentLength.FORTY_FIVE_FEET;
      default:
        return null;
    }
  }


}
